module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('div', {
    staticClass: "inbox"
  }, [_c('bsf-page-header', [_c('h3', {
    slot: "header"
  }, [_vm._v("图表/charts ")])]), _vm._v(" "), _c('breadcrumb', {
    attrs: {
      "data": _vm.$store.state.bcArray
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('bsf-layout', [_c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "6"
    }
  }, [_c('bsf-panel', [_c('h5', {
    staticClass: "panel-title",
    slot: "title"
  }, [_vm._v("图表 Echart line")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('bsf-chart', {
    attrs: {
      "cheight": "400",
      "data": _vm.chartData,
      "ctitle": "数据统计信息折线图",
      "ctype": "line"
    }
  })])], true)]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "6"
    }
  }, [_c('bsf-panel', [_c('h5', {
    staticClass: "panel-title",
    slot: "title"
  }, [_vm._v("图表 Echart line区域图")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('bsf-chart', {
    attrs: {
      "cheight": "400",
      "data": _vm.chartData1,
      "ctitle": "数据统计信息面积图",
      "ctype": "line",
      "areaStyle": true
    }
  })])], true)]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "6"
    }
  }, [_c('bsf-panel', [_c('h5', {
    staticClass: "panel-title",
    slot: "title"
  }, [_vm._v("图表 Echart 柱状图")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('bsf-chart', {
    attrs: {
      "cheight": "400",
      "data": _vm.chartData2,
      "ctitle": "数据统计信息柱状图",
      "ctype": "bar"
    }
  })])], true)]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "6"
    }
  }, [_c('bsf-panel', [_c('h5', {
    staticClass: "panel-title",
    slot: "title"
  }, [_vm._v("图表 Echart 饼状图")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('bsf-chart', {
    attrs: {
      "cheight": "400",
      "data": _vm.chartData3,
      "ctitle": "数据统计信息饼状图",
      "ctype": "pie"
    }
  })])], true)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-8412ab32!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/chart.vue
// module id = 328
// module chunks = 2